import { Component } from '@angular/core';
import { frontendserverurl } from '../../../environments/environment';
import { UserdataService } from '../../service/userdata.service';
import { AppdataService } from '../../service/appdata.service';

@Component({
    selector: 'app-categories',
    standalone: false,
    templateUrl: './categories.component.html',
    styleUrl: './categories.component.scss'
})
export class CategoriesComponent {
    userData: any;
    showName: boolean = false;
    name = "";
    images: any[] = [];
    frontendurl = frontendserverurl;

    constructor(
        private user: UserdataService,
        private data: AppdataService
    ) {
        this.userData = this.user.data.subscribe(data => {
            this.userData = data;
            if (this.userData.prename) {
                this.name = this.userData.prename;
                this.showName = true;
            }



        });
        this.data.categoryImagesThumbs.subscribe(data => this.images = data)

    }
}
